export const EBP_FIRST_CONNECTION_KEY = 'Ebp.FirstConnection';
export const EBP_USER_SETTINGS_KEY = 'Ebp.UserSettings';